import React, { useState, useRef, useEffect, Fragment } from "react";
import {
    Badge,
    Search,
    DatePickerInput,
    Button,
    DataTable,
    Filter,
    Modal,
    Icon,
    Breadcrumb
} from "pepsico-ds";
import "./extension_reactivation.css";
import { useNavigate } from "react-router-dom";
import arReactivateService from "../../services/arReactivateService";
import { toast, ToastContainer } from "react-toastify";
import { useTranslation } from "react-i18next";


const SingleExtensionReactivation = () => {
    const [selectedDate, setSelectedDate] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [searchInput, setSearchInput] = useState("");
    const [selectedRow, setSelectedRow] = useState(null);
    const [reactivatedData, setReactivatedData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [showNoDataFound, setShowNoDataFound] = useState(false);
    const [requestData, setRequestData] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isDateError, setIsDateError] = useState(false);
    const [dateError, setDateError] = useState(null);
    const [pageIndex, setPageIndex] = useState(0);
    const [previousDate, setPreviousDate] = useState(null);
    const [selectedMaintenanceType, setSelectedMaintenanceType] = useState(null);
    // const [rowData, setRowData] = useState(null);
    const rowData = useRef()
    const [step, setStep] = useState(1);
    const [warningMsg, setWarningMsg] = useState("");
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    const [copyButtonText, setCopyButtonText] = useState(t('nonArExtension.copy'));
    const [selectedFilter, setSelectedFilter] = useState({
        id: '1',
        label: t('nonArExtension.gpid'),
    });
    const selectedFilterRef = useRef({
        id: '1',
        label: t('nonArExtension.gpid'),
    })

    useEffect(() => {
        // Create a MutationObserver to watch for attribute changes
        const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.type === "attributes" && mutation.attributeName === "data-lang") {
                const extensionFilterOptions = [
                        { id: "1", label: t('nonArExtension.gpid') },
                        { id: "2", label: t('nonArExtension.first_name') },
                        { id: "3", label: t('nonArExtension.last_name') },
                        { id: "4", label: t('nonArExtension.email') },
                    ];
                const prevSelectedFilter = {...selectedFilterRef.current};
                setSelectedFilter(extensionFilterOptions?.find?.((o)=>o.id === prevSelectedFilter.id));
            }
        });
        });

        // Start observing the body element
        observer.observe(document.body, {
        attributes: true,
        attributeFilter: ["data-lang"],
        });

        // Cleanup observer on unmount
        return () => {
        observer.disconnect();
        };
    }, []);

    const onClickToGoBack = () => {
        navigate(-1);
    }

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    // useEffect(() => {
    //     const attachPaginationListeners = () => {
    //         const buttons = document.querySelectorAll('.single-extension-table  .footer #pagination #table-pagination li button');
    //         buttons?.forEach((btn) => {

    //             btn.removeEventListener("click", handlePageClick);
    //             btn.addEventListener("click", handlePageClick);
    //         });
    //     };

    //     const handlePageClick = (e) => {
    //         const index = parseInt(e.currentTarget.getAttribute("data-index"), 10);
    //         setPageIndex(index);

    //     };

    //     const timeout = setTimeout(attachPaginationListeners, 1000);

    //     return () => {
    //         clearTimeout(timeout);
    //         const buttons = document.querySelectorAll('.single-extension-table  .footer #pagination #table-pagination li button');
    //         buttons?.forEach((btn) => {
    //             btn.removeEventListener("click", handlePageClick);
    //         });
    //     };
    // }, [reactivatedData]);
    const onRowSelectionChange = (e = null, user) => {
        if (e) {
          e.stopPropagation();
        }
        const selectedRow = rowData?.current?.find?.((a) => a.gpid == user.gpid);
        console.log("rowData:::::::::", selectedRow);
        const date = new Date();
      
        // Safely format previousDate
        if (selectedRow?.previousDate && !isNaN(new Date(selectedRow.previousDate))) {
          const formatted = new Intl.DateTimeFormat("en-US", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit"
          }).format(new Date(selectedRow.previousDate));
          setPreviousDate(formatted);
        } else {
          console.warn("Invalid or missing previousDate:", selectedRow?.previousDate);
          setPreviousDate(null); // or set a fallback value
        }
        setSelectedMaintenanceType(selectedRow?.maintenanceType || null);
      
        const newDate = addDaysToDate(date);
        console.log("formattedDate::::::::::::", newDate);
        setSelectedDate(newDate);
        setSelectedRow(user);
        selectedGPID.current = user.gpid;

        // setTimeout(() => {
        //     const targetButton = document.querySelector(
        //         `.single-extension-table  .footer #pagination #table-pagination li button[data-index="${pageIndex}"]`
        //     );
        //     if (targetButton) {
        //         console.log(`Triggering click on page ${pageIndex}`);
        //         targetButton.click();
        //     } else {
        //         console.warn("Pagination button not found for index:", pageIndex);
        //     }
        // }, 10);
    };
    function addDaysToDate(prevDate) {
        let oldDate = new Date(prevDate);
        let newDate = new Date(oldDate);
        newDate.setDate(oldDate.getDate() + 90);
        return newDate;
    }

    const selectedGPID = useRef('');
    let columns= [
        { columnKey: "gpid", header: t("nonArExtension.gpid"), initialSize: 140, cellData: (ctx) => {
            return <>
                <input
                    type="radio"
                    name="row-selection"
                    value={ctx.row.original.gpid}
                    checked={!!(selectedGPID.current && selectedGPID.current === ctx.row.original.gpid)}
                    onChange={(e) => onRowSelectionChange(e, ctx.row.original)}
                    style={{ textAlign: 'center', marginRight: '10px' }}
                />
                    {ctx.row.original.gpid}
                </>
        }},
        // { columnKey: "maintenanceType", header: t("nonArExtension.maintenance_type"), initialSize: 220 },
        { columnKey: "firstName", header: t("nonArExtension.first_name"), initialSize: 150, showColumnVisibility: true },
        { columnKey: "lastName", header: t("nonArExtension.last_name"), initialSize: 150 },
        { columnKey: "manager", header: t("nonArExtension.manager"), initialSize: 140 },
        { columnKey: "associateType", header: t("updateProfile.associateType"), initialSize: 220 },
        { columnKey: "status", header: t("nonArExtension.column_status"), size: 130 },
        { columnKey: "startDate", header: t("nonArExtension.start_date"), initialSize: 140 },
        { columnKey: "email", header: t("nonArExtension.email"), initialSize: 220 },
    ];

    // useEffect(()=>{
    //     setColumns([
    //         { columnKey: "gpid", header: t("nonArExtension.gpid"), initialSize: 140, cellData: (ctx) => {
    //             return <>
    //                 <input
    //                     type="radio"
    //                     name="row-selection"
    //                     value={ctx.row.original.gpid}
    //                     checked={!!(selectedGPID.current && selectedGPID.current === ctx.row.original.gpid)}
    //                     onChange={(e) => onRowSelectionChange(e, ctx.row.original)}
    //                     style={{ textAlign: 'center', marginRight: '10px' }}
    //                 />
    //                     {ctx.row.original.gpid}
    //                 </>
    //         }},
    //         // { columnKey: "maintenanceType", header: t("nonArExtension.maintenance_type"), initialSize: 220 },
    //         { columnKey: "firstName", header: t("nonArExtension.first_name"), initialSize: 150, showColumnVisibility: true },
    //         { columnKey: "lastName", header: t("nonArExtension.last_name"), initialSize: 150 },
    //         { columnKey: "manager", header: t("nonArExtension.manager"), initialSize: 140 },
    //         { columnKey: "associateType", header: t("updateProfile.associateType"), initialSize: 220 },
    //         { columnKey: "status", header: t("nonArExtension.column_status"), size: 130 },
    //         { columnKey: "startDate", header: t("nonArExtension.start_date"), initialSize: 140 },
    //         { columnKey: "email", header: t("nonArExtension.email"), initialSize: 220 },
    //     ]);
    // },[selectedRow]);

    // const columns = [
    //     { columnKey: "radio", header: "", },
    //     { columnKey: "gpid", header: t("nonArExtension.gpid"), initialSize: 220 },
    //     // { columnKey: "maintenanceType", header: t("nonArExtension.maintenance_type"), initialSize: 220 },
    //     { columnKey: "firstName", header: t("nonArExtension.first_name"), initialSize: 220, showColumnVisibility: true },
    //     { columnKey: "lastName", header: t("nonArExtension.last_name"), initialSize: 220 },
    //     { columnKey: "manager", header: t("nonArExtension.manager"), initialSize: 220 },
    //     { columnKey: "associateType", header: t("updateProfile.associateType"), initialSize: 220 },
    //     { columnKey: "status", header: t("nonArExtension.column_status"), size: 130 },
    //     { columnKey: "startDate", header: t("nonArExtension.start_date"), initialSize: 220 },
    //     { columnKey: "email", header: t("nonArExtension.email"), initialSize: 220 },
    // ];

    const onSelectFilter = (data) => {
        setSelectedFilter(data);
        selectedFilterRef.current = data;
    };

    useEffect(() => {
        if (!selectedDate) return;
        const newDate = new Date(selectedDate);
        const prevDate = new Date();
        const maxAllowedDate = new Date(prevDate);
        maxAllowedDate.setDate(prevDate.getDate() + 90);
        const newUTC = Date.UTC(newDate.getFullYear(), newDate.getMonth(), newDate.getDate());
        const maxUTC = Date.UTC(maxAllowedDate.getFullYear(), maxAllowedDate.getMonth(), maxAllowedDate.getDate());
        const prevUTC = Date.UTC(prevDate.getFullYear(), prevDate.getMonth(), prevDate.getDate());

        if (newUTC > maxUTC) {
            setIsDateError(true);
            toast.error(t('nonArExtension.error_date_range_max', { date: prevDate.toLocaleDateString() }));
            setSelectedDate(null);
        } else if (newUTC < prevUTC) {
            setIsDateError(true);
            toast.error(t('nonArExtension.error_date_range_min', { date: prevDate.toLocaleDateString() }));
            setSelectedDate(null);
        } else {
            setIsDateError(false);
            setDateError(null);
        }
    }, [selectedDate]);

    useEffect(() => {
        if (reactivatedData.length > 0) {
            onRowSelectionChange(null, reactivatedData[0]);
        }
    }, [reactivatedData]);


    const fetchUserData = async (selectedFilter) => {
        setLoading(true);
        setError(null);
        if (selectedRow && previousDate && selectedDate) {
            setSelectedRow(null);
            setPreviousDate(null);
            setSelectedDate(null);
            setSelectedMaintenanceType(null);
        }
        try {
            const filterMapping = {
                [t('nonArExtension.gpid')]: "gpid",
                [t('nonArExtension.first_name')]: "firstName",
                [t('nonArExtension.last_name')]: "lastName",
                [t('nonArExtension.email')]: "emailAddress"
            }
            let key = filterMapping[selectedFilter.label];
            let userId = key ? { [key]: searchInput } : {};
            const response = await arReactivateService.getReactivatedUser(userId);
            const allRows = Object.entries(response.data.mapOfRevalidationReactivateResponse).map(([gpid, user]) => ({
                gpid: gpid.trim(),
                previousDate: user.pepEffectiveDate,
                newDate: user.pepRevalidationDate,
                maintenanceType: user?.pepUserStatus ? user?.pepUserStatus?.toLowerCase?.() === "active" ? "Extension" : "Reactivate" : ""
            }));
            // setRowData(allRows);
            rowData.current = allRows
            const transformedData = Object.entries(response.data.mapOfRevalidationReactivateResponse).map(([gpid, user]) => ({
                gpid: gpid.trim(),
                maintenanceType: user?.pepUserStatus ? user?.pepUserStatus?.toLowerCase?.() === "active" ? "Extension" : "Reactivate" : "",
                firstName: user?.givenName?.trim() || "",
                lastName: user?.sn?.trim() || "",
                manager: user.pepReportingManager || "",
                startDate: user.pepEffectiveDate || "",
                email: user.mail || "",
                associateType: user?.pepUserType || "",
                status: user?.pepUserStatus || ""
            }));
            // onRowSelectionChange(null, transformedData[0]);
            setReactivatedData(transformedData);
            setSearchInput("");
        } catch (err) {
            setError(err.message || t('nonArExtension.error_api'));
        } finally {
            setLoading(false);
            if(!showNoDataFound)setShowNoDataFound(true);
        }
    };


    const closeModal = () => {
        setShowModal(false);
    };

    const onClickCopynumber = () => {
        if (requestData?.requestId) {
            navigator.clipboard
                .writeText(requestData.requestId.toString())
                .then(() => {
                    setCopyButtonText(t('nonArExtension.copied'));
                })
                .catch((err) => {
                    console.error("Failed to copy text: ", err);
                });
        }
    };

    const renderConfirmModal = () => {
        return (
            <div className="confirm-modal">
                <Modal
                    showModal={showModal}
                    className="reactivation-modal"
                    onCloseModal={closeModal}
                    closeOnOutsideClick
                    notificationsProps={{
                        secondaryActionLabel: (
                            <>
                                <Icon
                                    alt="alt value"
                                    icon={copyButtonText == t('nonArExtension.error_api') ? "check" : "content_copy"}
                                    size="medium"
                                    style={{ marginRight: "6px", display: "unset" }}
                                />
                                {copyButtonText}
                            </>
                        ),
                        secondaryActionOnClick: onClickCopynumber,
                        text: `${requestData.requestId}`,
                        title: t('nonArExtension.request_number_title'),
                        type: "info",
                    }}
                    showAuxiliaryButton={false}
                    showLink={false}
                    showPrimaryButton={false}
                    showSecondaryButton={false}
                    showSlot
                    showTertiaryButton={false}
                    showCloseButton={true}
                    text={
                        <>
                            {`${requestData && `${requestData.status}! ${requestData.message}`}`}
                            <br />
                            <div style={{ marginTop: "16px" }}>
                                {t('nonArExtension.extension_confirmation_body')}
                            </div>
                            <div className="user-badge">
                                <small>{`${selectedRow?.firstName} ${selectedRow?.lastName} ⋅ ${selectedRow?.gpid}`}</small>
                            </div>
                        </>
                    }
                    title={t('nonArExtension.extension_confirmation_title')}
                    type="fluid"
                    viewPort="desktop"
                >
                    <div>
                        <p>{t('nonArExtension.see_requests_prompt')}</p>
                    </div>
                    <div className="confirm-modal-btn">
                        <Button
                            size="medium"
                            text={t('nonArExtension.back')}
                            variant="tertiary"
                            onClick={closeModal}
                        />
                        <Button size="medium" onClick={() => onClickPendingRequest(requestData.requestId)} text={t('nonArExtension.view_req_title')} variant="primary" />
                    </div>
                </Modal>
            </div>
        );
    };

    const onClickPendingRequest = (requestId) => {
        const statePayload = { type: "requestNumber", value: requestId };
        navigate("/audit-requests", { state: statePayload });
    }

    const onClickSubmit = async () => {
        setIsSubmitting(true);
        const dateObj = new Date(selectedDate);
        const formatted = dateObj.toLocaleDateString("en-US", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
        });
        const data = {
            gpid: selectedRow.gpid,
            newReactivateDate: formatted,
        };
        console.log("data::::::::::", data);
        try {
            const response = await arReactivateService.updateReactivatedUser(data);
            if (response.status == 200) {
                if (response.data.status == "Failed") {
                    toast.error(response.data.errorMessage);
                    setIsSubmitting(false);
                    return;
                }
                setRequestData(response.data);
                setIsSubmitting(false);
                setShowModal(true);
            } else {
                toast.error(t('nonArExtension.error_api'));
                setIsSubmitting(false);
                return;
            }
        } catch (error) {
            toast.error(t('nonArExtension.error_api'));
            setIsSubmitting(false);
        }
    };

    const onClickSearch = () => {
        // if (selectedFilter?.id === "4" && searchInput) {
        //     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        //     if (!emailRegex.test(searchInput)) {
        //         toast.error("Please enter a valid email address");
        //         return;
        //     }
        // }
        if (selectedFilter && selectedFilter.label == "GPID") {
            if (!searchInput || searchInput.length < 4) {
                toast.error("Minimum 4 digits required");
                return
            }
        }
        if (selectedFilter) {
            fetchUserData(selectedFilter);
        }
    };

    const onChangeFilter = (value) => {
        setSelectedFilter(value);
        selectedFilterRef.current = value;
        setSearchInput("");
        setReactivatedData([]);
        setPreviousDate(null);
        setSelectedMaintenanceType(null);
        setSelectedDate(null);
    };

    const handleSearchInputChange = (value) => {
        let filteredValue = value;
        console.log("selectedFilter:::::", selectedFilter);
        switch (selectedFilter?.id) {
            case "1":
                filteredValue = value.replace(/[^0-9]/g, "");
                break;

            case "2":
            case "3":
                filteredValue = value.replace(/[^A-Za-z\s]/g, "");
                break;

            // case "4":
            //     filteredValue = value.replace(/[^A-Za-z0-9@._-]/g, "");
            //     break;

            default:
                break;
        };
        setSearchInput(filteredValue);
    }
    const capitalizeFirstLetter =((str)=> {
        if (!str) return '';
        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
      });
      
    const capitalizeEveryFirstLetter =((str)=> {
        if (!str) return '';
        const strArr = str?.split?.(" ");
        return strArr?.map?.((str)=> str.charAt(0).toUpperCase() + str.slice(1).toLowerCase())?.join?.(" ");
    });

    // const reactivatedUserData = reactivatedData.map((user) => ({
    //     radio: (
    //         <input
    //             type="radio"
    //             name="row-selection"
    //             value={user.gpid}
    //             checked={!!(selectedRow && selectedRow.gpid === user.gpid)}
    //             onChange={(e) => onRowSelectionChange(e, user)}
    //             style={{ marginRight: '5px', textAlign: 'center' }}
    //         />
    //     ),
    //     ...user,
    // }));

    const backToDashboard = () => {
        return (
            <>
                <div className="dashboard-btn" onClick={onClickToGoBack}><Icon
                    alt="alt value"
                    icon="arrow_back"
                    size="medium"
                    style={{ marginRight: '8px' }}
                />{t('nonArExtension.back_to_dashboard')}</div>
            </>
        )
    }

    const renderSearchSection = () => {
        return (
            <>
                <Filter
                    // isClearable={true}
                    // label={t('nonArExtension.select_criteria')}
                    menuPosition="bottom-right"
                    onChange={(value) => {
                        onChangeFilter(value);
                    }}
                    options={[
                        { id: "1", label: t('nonArExtension.gpid') },
                        { id: "2", label: t('nonArExtension.first_name') },
                        { id: "3", label: t('nonArExtension.last_name') },
                        { id: "4", label: t('nonArExtension.email') },
                    ]}
                    selection="single"
                    size={`${isMobile ? "small" : "medium"}`}
                    showSearch={false}
                    style={{ marginBottom: `${isMobile ? "16px" : "unset"}` }}
                    value={selectedFilter}
                />
                <div>
                    <Search
                        value={searchInput}
                        isClearable={!!searchInput.length}
                        menuPosition="bottom-right"
                        onClear={function oFe() { }}
                        onSearch={() => onClickSearch()}
                        onSelectOption={function oFe() { }}
                        onUpdate={handleSearchInputChange}
                        // disabled={!selectedFilter}
                        placeholderText={t('nonArExtension.search_placeholder')}
                        size="medium"
                        delay={0}
                    />
                    {(selectedFilter && selectedFilter.label == "GPID") && (
                        <div style={{ fontSize: "12px", color: "#808080" }}>{t('nonArExtension.info_message')}</div>
                    )}
                    {warningMsg && (
                        <div style={{ color: "red", marginTop: "5px", fontSize: "12px" }}>
                            {warningMsg}
                        </div>
                    )}
                </div>
            </>
        );
    };

    const renderDataTable = () => {
        return (
            <div className="single-extension-table  other-request-list hide-rows-per-page">
                <DataTable
                    key={i18n.language}
                    className="datatable single-extension-table other-request-list"
                    columns={columns}
                    data={reactivatedData}
                    // isResizable={false}
                    enableSorting={true}
                    paginationDefaultPage={pageIndex}
                    // manualPagination={true}
                    onPageIndexChange={(newSelectedPage) => {
                        console.info(`[DataTable.onUpdate] newPage = ${newSelectedPage}`) // Add custom function to handle page change
                    }}
                    // pageIndex={pageIndex}
                    pageSize={10}
                    // totalRowsCount={50}
                    searchPlaceholder={t('nonArExtension.search_placeholder')}
                    selection="single"
                    showColumnFilters={false}
                    showDescription={false}
                    // showFilterButton={false}
                    // showFilterToolbar={false}
                    // showMultiSortMenu={false}
                    // showPagination={true}
                    showSearchOption={false}
                    showTableHeader={false}
                    showTitle={false}
                    size="large"
                    pageIndex={0}
                    tableDescription=""
                    tableHeader=""
                />
            </div>
        )
    }

    const renderChangeDateSection = () => {
        return (
            <>
                <div className="form-section">
                    <h6>{t('nonArExtension.select_new_expiration_date')}</h6>
                    <div className="form-group">
                        <label>{capitalizeEveryFirstLetter(t("nonArExtension.start_date"))}</label>
                        <p
                            style={{
                                color: "#3A3A3A",
                                fontSize: "14px",
                                fontWeight: "400",
                            }}
                        >
                            {previousDate || "-"}
                        </p>
                    </div>

                    <div className="form-group">
                        <label>{capitalizeEveryFirstLetter(t("nonArExtension.maintenance_type"))}</label>
                        <p
                            style={{
                                color: "#3A3A3A",
                                fontSize: "14px",
                                fontWeight: "400",
                            }}
                        >
                            {selectedMaintenanceType || "-"}
                        </p>
                    </div>

                    <div className="form-group extension-date-picker">
                        <DatePickerInput
                            endYear={2030}
                            feedbackType="info"
                            helperText={t('nonArExtension.new_expiration_helper')}
                            format="mm/dd/yyyy"
                            inputSize="medium"
                            label={capitalizeEveryFirstLetter(t('nonArExtension.new_expiration_label'))}
                            placeholder="mm/dd/yyyy"
                            required
                            selected={selectedDate}
                            setSelected={setSelectedDate}
                            startYear={1950}
                            error={isDateError}
                            showClearIcon={false}
                        />
                    </div>

                    <div className="submit-button">
                        <Button
                            size="medium"
                            text={isSubmitting ? t('nonArExtension.submitting') : t('nonArExtension.submit')}
                            variant="primary"
                            disabled={isSubmitting || (selectedRow?.gpid && !selectedDate) || !selectedRow?.gpid }
                            onClick={onClickSubmit}
                        />
                    </div>
                </div>
            </>)
    }

    const renderToastContainer = () => {
        return (
            <ToastContainer
                position="bottom-center"
                autoClose={5000}
                hideProgressBar={false}
                closeOnClick
                pauseOnHover
                draggable
            />
        )
    }

    const renderErrorMesg = () => {
        return (
            <>
                <Icon
                    alt="alt value"
                    icon="mobiledata_off"
                    size="large"
                    style={{}}
                />
                <span className="error-title">{t('nonArExtension.error_no_data_title')}</span>
                <span className="error-subtitle">{t('nonArExtension.error_no_data_subtitle')}</span>
            </>
        );
    };

    const initialRenderErrorMesg = () => {
        return (
            <>
                <Icon
                    alt="alt value"
                    icon="mobiledata_off"
                    size="large"
                    style={{}}
                />
                {/* <span className="error-title">No data to display</span> */}
                <span className="error-subtitle">{t('nonArExtension.initial_msg')}</span>
            </>
        );
    };


    const renderDesktopExtension = () => {
        return (
            <>
                <div className="extension-container">
                    <Breadcrumb
                        homeIcon={{
                            icon: "home",
                            onClick:()=>{
                            navigate("/home")
                            }
                        }}
                        breadcrumbs={[
                            {
                                label: t('nonArExtension.home')
                            },
                            {
                                label: <div onClick={()=>{
                                    navigate("/myidmPortal")
                                }}>{t('nonArExtension.myidm')}</div>
                            },
                            {
                                label: <div onClick={()=>{
                                    navigate("/myidmPortal")
                                }}>{t('nonArExtension.manager_acc_title')}</div>
                            },
                            {
                                label: t('nonArExtension.single_revalidation')
                            }
                        ]}
                        className=""
                        style={{}}
                    />
                    <h4 className="extension-page-title" style={{ marginTop: !isMobile ? "10px" : "0px" }}>
                        {t('nonArExtension.extension_title')}
                    </h4>
                    <div className="extension-content-wrapper">
                        <div className="step-one">
                            <div className="step-header">{t('nonArExtension.step1_title')}</div>
                            <div className="extension-divider"></div>
                            <div className="search-container">
                                <div className="search-seaction">
                                    <h6 className="search-title">{t('nonArExtension.step1_subtitle')}</h6>
                                    <div className="search-subtitle">
                                        {t('nonArExtension.step1_description')}
                                    </div>
                                </div>
                                <div className="search-bar">
                                    {renderSearchSection()}
                                </div>
                            </div>
                            {!loading && !error && reactivatedData && reactivatedData.length > 0 ? (
                                renderDataTable()
                            ) : (
                                !loading &&
                                !error && 
                                showNoDataFound &&(
                                    <div className="error-container">
                                        {error ? <span className="search-subtitle">{error}</span> : (selectedFilter) ? renderErrorMesg() : initialRenderErrorMesg()}
                                    </div>
                                )
                            )}
                            {error && (
                                <div className="error-container">
                                    {renderErrorMesg()}
                                </div>
                            )}
                            {loading && (
                                <div className="loading-container">
                                    <span className="search-subtitle">
                                        {t('nonArExtension.loading')}
                                    </span>
                                </div>
                            )}
                        </div>

                        <div className="step-two">
                            <div className="step-header">{t('nonArExtension.step2_title')}</div>
                            <div className="extension-divider"></div>
                            {renderChangeDateSection()}
                        </div>
                    </div>
                    {renderToastContainer()}
                    {showModal && renderConfirmModal()}
                </div>
            </>
        )
    }

    const renderMobileExtension = () => {
        return (
            <div className="mobile-extension-container">
                {backToDashboard()}
                <div className="mobile-extension-content">
                    <h6 className="extension-page-title">
                        {t('nonArExtension.extension_title')}
                    </h6>
                </div>
                {/* <div className="mobile-extension-steps">
                    <div className={`mobile-extension-step-text ${step === 1 ? "active" : ""}`} onClick={() => setStep(1)}>STEP 1: FIND AN ASSOCIATE</div>
                    <div className={`mobile-extension-step-text ${step === 2 ? "active" : ""}`} onClick={() => setStep(2)}>STEP 2: CHANGE</div>
                </div> */}
                {/* {step === 1 && ( */}
                <div className="mobile-extension-step-one">
                    <h6 className="mobile-search-title">{t('nonArExtension.step1_description')}</h6>
                    <div className="search-subtitle">
                        {t('nonArExtension.search_results')}
                    </div>
                    <div className="mobile-search-bar">
                        {renderSearchSection()}
                    </div>
                    {!loading && !error && reactivatedData && reactivatedData.length > 0 ? (
                        <>
                            {renderDataTable()}
                            {renderChangeDateSection()}
                        </>
                    ) : (
                        !loading &&
                        !error && 
                        showNoDataFound &&(
                            <div className="error-container">
                                {error ? <span className="search-subtitle">{error}</span> : renderErrorMesg()}
                            </div>
                        )
                    )}
                    {error && (
                        <div className="error-container">
                            {renderErrorMesg()}
                        </div>
                    )}
                    {loading && (
                        <div className="loading-container">
                            <span className="search-subtitle">
                                {t('nonArExtension.loading')}
                            </span>
                        </div>
                    )}
                </div>
                {/* )} */}


                {renderToastContainer()}
                {showModal && renderConfirmModal()}
            </div>
        )
    }

    return isMobile ? renderMobileExtension() : renderDesktopExtension();

};

export default SingleExtensionReactivation;
